import { render, staticRenderFns } from "./smileStandard.vue?vue&type=template&id=98008f0a"
import script from "./smileStandard.vue?vue&type=script&lang=js"
export * from "./smileStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports